import { View, DimensionValue, Platform, Pressable, StyleSheet, ViewStyle } from "react-native";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";

import CustomTextInput from "../CustomTextInput/CustomTextInput";
import { useState } from "react";
import { colors } from "../../../../styles/design-system";

const CustomSearchInput = ({
  placeholder = "Search by any value",
  searchQuery,
  setSearchQuery,
  minWidth,
  containerStyle,
}: {
  placeholder?: string;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  minWidth?: DimensionValue;
  containerStyle?: ViewStyle;
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const handlePress = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };
  return (
    <View
      style={[
        styles.searchContainer,
        { minWidth: minWidth ?? 250, borderColor: isFocused ? "#2563eb" : "#d0d5dd", borderWidth: isFocused ? 2 : 1 },
        containerStyle,
      ]}>
      <MagnifyingGlassIcon size={16} color="#64748b" style={styles.searchIcon} />
      <Pressable onFocus={handlePress} onBlur={handleBlur}>
        <CustomTextInput
          placeholder={placeholder}
          placeholderTextColor={colors.grey[500]}
          selectionColor="#6B7280"
          cursorColor="#6B7280"
          value={searchQuery}
          onChangeText={setSearchQuery}
          onFocus={handlePress}
          onBlur={handleBlur}
          style={[
            styles.searchInput,
            Platform.select({
              web: {
                outlineStyle: "none",
                outlineWidth: 0,
                WebkitAppearance: "none",
              } as unknown,
            }),
          ]}
        />
      </Pressable>
    </View>
  );
};

export default CustomSearchInput;

const styles = StyleSheet.create({
  searchContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#d0d5dd",
    borderRadius: 8,
    paddingVertical: 4,
    paddingHorizontal: 12,
  },
  searchIcon: {
    marginRight: 8,
    flexShrink: 0,
  },
  searchInput: {
    flex: 1,
    borderWidth: 0,
    backgroundColor: "transparent",
    padding: 8,
    fontSize: 14,
    color: "#101828",
  },
});
